const defaultCandidate = {
  _id: null,
  document: null,
  name: null,
  email: null,
  phone: null,
  birthDate: null,
  fatherName: null,
  motherName: null,
  country: null,
  postalCode: null,
  street: null,
  addressNumber: null,
  neighborhood: null,
  city: null,
  addressState: null,
  createdBy: null,
  updatedBy: null
}

const state = {
  candidate: defaultCandidate
}

const getters = {}

const mutations = {
  SET_CANDIDATE: (state, payload) => {
    state.candidate = payload
  }
}

const actions = {
  loadCandidate({ commit }, candidateData) {
    commit('SET_CANDIDATE', candidateData)
  },
  clearCandidate({ commit }) {
    const defCandidate = {
      _id: null,
      document: null,
      name: null,
      email: null,
      phone: null,
      birthDate: null,
      fatherName: null,
      motherName: null,
      country: null,
      postalCode: null,
      street: null,
      addressNumber: null,
      neighborhood: null,
      city: null,
      addressState: null,
      createdBy: null,
      updatedBy: null
    }
    commit('SET_CANDIDATE', defCandidate)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
